import { PageHeader } from "@/components/common/ui-kit";
import { LicensesList } from "@/components/assets/LicensesList";
import { DocsList } from "@/components/assets/DocsList";

export function LicensesPage() {
  return (
    <div data-testid="licenses-page">
      <PageHeader overline="Asset & Contratti" title="Licenze" description="Diritti d'uso software e servizi: quantità, validità, rinnovi e assegnazioni ad asset, contatti, utenti e sedi." />
      <LicensesList />
    </div>
  );
}

export function CommercialDocsPage() {
  return (
    <div data-testid="commercial-docs-page">
      <PageHeader overline="Asset & Contratti" title="Documenti commerciali" description="Archivio strutturato dei riferimenti (offerte, ordini, accettazioni, rinnovi). I file saranno gestiti dalla Fase 8." />
      <DocsList />
    </div>
  );
}
